module.exports = __webpack_public_path__ + "media/images/athletes/3591-1ad5ea0b5c7896c469947e00114284f1.png";